export const CustomIt = {
  TITLE: "Codice",
  BLOCKS: "Blocchi",
  LINKTOOLTIP: "Salvare e collegare ai blocchi.",
  RUNTOOLTIP: "Avviare il programma definito dai blocchi nell'area di lavoro.",
  BADCODE: "Errore di programma:\n%1",
  TIMEOUT: "Numero massimo di iterazioni di esecuzione superato.",
  TRASHTOOLTIP: "Scartare tutti i blocchi.",
  CATLOGIC: "Logica",
  CATLOOPS: "Anello",
  CATMATH: "Matematica",
  CATALGEBRA: "Algebra",
  CATANALYSIS: "Analisi",
  CATARITHMETIC: "Aritmetica",
  CATGEOMETRY: "Geometria",
  CATMATRIX: "Matrices",
  CATSTATS: "Stats",
  CATLANG: "Lang",
  CATFRENCH: "Francese",
  CATTEXT: "Testi",
  CATLISTS: "Elenco",
  CATCOLOUR: "Colore",
  CATVARIABLES: "Variabile",
  CATFUNCTIONS: "Procedura",
  CATMEDIA: "Media",
  LISTVARIABLE: "cast",
  TEXTVARIABLE: "testo",
  HTTPREQUESTERROR: "C'è stato un problema con la domanda.",
  LINKALERT: "Condividi i tuoi blocchi attraverso questo link:\n1",
  HASHERROR: "Spiacente, '%1' non corrisponde a nessun programma salvato.",
  XMLERROR:
    "Impossibile caricare il file di backup.  Forse è stato creato con un'altra versione di Blockly?",
  BADXML:
    'Selezionare "OK" per abbandonare le modifiche o "Annulla" per continuare a modificare l\'XML.',
  CATEXAMPLES: "Introduzione",
  CATSTART: "Avvio",
  CATDISPLAY: "Display",
  CATQUESTIONS: "Domanda",
  CATAI: "IA",
  CATFEEDBACK: "Feedback",

  CATOBJECTS: "Oggetti",
  //LABEL SEPARATORS
  LABEL_START: "Avvio",
  LABEL_FORMATTING: "Formattazione",
  LABEL_STYLES: "Stili",
  LABEL_EXPERT: "Intelligente",

  LABEL_NUMBERS: "Numeri",
  LABEL_CALCULUS: "Calcolo",
  LABEL_ARITHMETICS: "Aritmetica",
  LABEL_FRACTIONS: "Frazioni",
  LABEL_UNITS: "Unità",

  LABEL_FUNCTIONS: "Funzioni",
  LABEL_TOOLS: "Strumenti",
  LABEL_GRAPHIC: "Grafico",

  LABEL_OBJECTS: "Oggetti",
  LABEL_TRANSFORMATIONS: "Trasformazioni",
  LABEL_CALCULUSES: "Calcoli",
  LABEL_DISPLAY: "Display",

  LABEL_LIST_EXPERT: "Intelligente",
  LABEL_MATRIX_EXPERT: "Intelligente",

  //EXAMPLES CAT
  EXAMPLES_PRINCIPLE_TITLE: "Principio generale di costruzione",
  EXAMPLES_PRINCIPLE_DOCUMENTATION: `La progettazione di un'attività di base avviene con 3 blocchi principali:
- 1: un blocco di intestazione all'inizio dell'attività
- 2: Un blocco Statement sotto un blocco Display per mostrare la dichiarazione.
- 3: Uno o più blocchi di domande
La maggior parte dei blocchi ha campi precompilati con blocchi o valori predefiniti. Questo serve a guidarvi nella costruzione della vostra attività. Naturalmente, questi campi possono essere sostituiti da altri tipi di blocchi.`,

  //WORKSPACE
  DOWNLOAD_SCREENSHOT: "Scarica uno screenshot",
  DELETE_UNUSED_VARIABLES: "Eliminare le variabili inutilizzate",

  //START CAT
  //BLOCK INFO
  INFO_TITLE: "Attività",
  INFO_MESSAGE:
    "Titolo attività %1 lingua %2 descrizione %3 tentativi massimi%4 feedback predefinito%5",
  INFO_LANG_TOOLTIP: `Digitare il codice della lingua di due lettere (ad esempio "fr" per il francese, "en" per l'inglese...)`,
  INFO_TOOLTIP: `Il blocco di intestazione di un'attività. Deve essere collocato all'inizio dell'attività.
    - titolo: il titolo dell'attività
    - descrizione: breve descrizione dell'attività.
    - Feedback predefinito: corrisponde a un feedback automatico e globale dell'attività. È utile soprattutto quando l'attività prevede diverse domande. In questo caso, il feedback indicherà il successo in tutte le domande o il fallimento in meno di una.`,
  INFO_COMMENT:
    "Commentate qui il funzionamento del vostro codice per aiutare gli altri a comprenderlo e adattarlo.",
  //LANG
  LANG_MATRIX_TITLE: "Attività (multilingue)",
  LANG_MATRIX_DEFAULT_FEEDBACK: "feedback predefinito",
  LANG_MATRIX_MAX_ATTEMPTS: "tentativi max",
  LANG_MATRIX_ACTIVITY_TITLE: "TITOLARE",
  LANG_MATRIX_DESCRIPTION: "DESCRIZIONE",
  LANG_MATRIX_LANG: "LINGUA",
  LANG_MATRIX_KEY: "CHIAVE",
  LANG_MATRIX_DEFAULT_TEXT: "Testi",
  LANG_MATRIX_CODE: "",
  LANG_MATRIX_TOOLTIP: `Una tabella per la progettazione di attività in diverse lingue.
  Viene posizionato separatamente e sopra gli altri blocchi nello spazio di progettazione per essere caricato per primo.
  Ogni riga contiene una parola chiave seguita dalle sue traduzioni in ogni colonna.
  Ogni colonna corrisponde a un codice linguistico. La prima colonna è la lingua predefinita.
  Eleda rileva automaticamente la lingua del browser e visualizza la parola o la frase corrispondente alla parola chiave
  `,

  //LANG_TEXT
  LANG_TEXT_TITLE: "Testo multilingue.",
  LANG_TEXT_MESSAGE: "testo con chiave %1",
  LANG_TEXT_NOTFOUND: "Rif. non trovato",
  LANG_TEXT_TOOLTIP:
    "Restituisce la stringa corrispondente alla chiave e alla lingua definita dal browser",

  //BLOCK STATEMENT
  STATEMENT_TITLE: "Dichiarazione",
  STATEMENT_MESSAGE: "Dichiarazione %1",
  STATEMENT_TOOLTIP: `Contiene tutti gli elementi da visualizzare nella dichiarazione.
    Il più delle volte contiene blocchi "Display".`,
  //BLOCK DISPLAY_ELEMENT
  DISPLAY_ELEMENT_TITLE: "Afficher",
  DISPLAY_ELEMENT_MESSAGE: "afficher %1",
  DISPLAY_ELEMENT_LEFT_ALIGN: "allineato a sinistra.",
  DISPLAY_ELEMENT_CENTER_ALIGN: "centrato",
  DISPLAY_ELEMENT_RIGHT_ALIGN: "allineato a destra.",
  DISPLAY_ELEMENT_JUSTIFY_ALIGN: "giustificato",
  DISPLAY_ELEMENT_TOOLTIP: `Consente di visualizzare gli elementi in una "Dichiarazione".
    Il più delle volte è incluso nel blocco "Dichiarazione".
    Contiene tutti i tipi di blocchi: figure geometriche, matematica, grafica, testi...
    Se contiene elementi geometrici, verrà creato in un grafico predefinito con Xmin:0, Ymax:10, Xmax:10, Ymin:0.
    Permette inoltre, durante la fase di progettazione, di verificare rapidamente i diversi valori e le variabili dell'attività (debugging).`,
  //PARAGRAPH (RICHTEXT)
  RICHTEXT_CREATE_WITH_TITLE: "paragrafo",
  RICHTEXT_CREATE_WITH_INPUT_WITH: "creare un paragrafo con ",
  RICHTEXT_CREATE_WITH_TOOLTIP: `Consente di combinare gli elementi per visualizzarli uno dopo l'altro in un paragrafo.
    Restituisce un paragrafo con un elenco di oggetti da visualizzare.
    Il più delle volte è incluso in un blocco "Display".
    Il più delle volte contiene blocchi di tipo "Text", "LaTeX", "Markdown", "Geometry", "Nested question".`,

  //LATEX_PARAGRAPH (RICHTEXT)
  LATEX_PARAGRAPH_CREATE_WITH_TITLE: "Assemblaggio LaTeX",
  LATEX_PARAGRAPH_CREATE_WITH_INPUT_WITH: "creare un assemblaggio LaTeX con ",
  LATEX_PARAGRAPH_CREATE_WITH_TOOLTIP: `Permette di assemblare il codice LaTeX con i blocchi Eleda per visualizzarli annidati.
    Restituisce un assemblaggio LateX pronta per essere visualizzata.
    Il più delle volte è incluso in un blocco "Display".
    Il più delle volte contiene blocchi di tipo "Testo" (contenenti stringhe LaTeX), "Domanda di visualizzazione annidata", "Geometria", ecc.`,

  //ALIGNMENT  COLOUR RANDOM_COLOUR SIZE
  SET_ALIGNMENT_TOOLTIP:
    "Allinea il blocco di contenuto a sinistra, al centro o a destra. Il più delle volte contiene un blocco di paragrafi",
  SET_COLOUR_TOOLTIP:
    "Applicare un colore a un blocco. Questo blocco può essere applicato a molti blocchi diversi (testo, geometria, ecc.)",
  SET_COLOUR_RANDOM_TOOLTIP:
    "Applica un colore casuale a un blocco. Questo blocco può essere applicato a molti blocchi diversi (testo, geometria, ecc.)",
  SET_SIZE_TOOLTIP:
    "Applicare una dimensione a un blocco. Questo blocco può essere applicato a molti blocchi diversi (testo, domande, geometria, ecc.)",
  SET_ATTRIBUTE_MESSAGE: "imposta %1 con %2",
  SET_ATTRIBUTE_TOOLTIP:
    "Avanzate: questo blocco consente di applicare parametri specifici a determinati blocchi (vedere la Documentazione).",
  SET_ATTRIBUTE_DOCUMENTATION: `Avanzato: Questo blocco può contenere diversi tipi di blocchi e applicare loro proprietà specifiche in formato JSON.
    Questo blocco può contenere i seguenti blocchi e applicare loro i seguenti parametri:
    - Blocchi matematici (espressione algebrica ...):
    • 'smartDisplay' : "true" per impostazione predefinita. Cerca di semplificare e trasformare al meglio un'espressione matematica.  
    - Blocchi di geometria (poligoni, cerchi ...): 
    • 'fillColor' per riempire una figura con un colore determinato dal suo codice esadecimale (ad esempio '#ff0000') o da 'random'.
    • 'dash' per impostare un motivo tratteggiato. Il valore deve essere compreso tra 0 e 6. (0: linea piena, 1: linea tratteggiata, 3: linea con trattini normali...)
    • 'gruppo' per raggruppare i punti di un poligono, consentendo di traslare completamente il poligono spostando uno qualsiasi dei suoi vertici.

    - Blocco tabella dati: 'isBordered' (vero per impostazione predefinita) consente di visualizzare o meno i bordi delle celle, 'isStriped' (vero per impostazione predefinita) consente di rendere grigia ogni altra riga, 'isHoverable' (falso per impostazione predefinita) consente di illuminare le righe quando il mouse vi passa sopra
 `,

  //BLOCK MARKDOWN
  MARKDOWN_TITLE: "markdown",
  MARKDOWN_MESSAGE: "markdown %1",
  MARKDOWN_TOOLTIP: `Consente di utilizzare la notazione Markdown.
    Restituisce un oggetto HTML da visualizzare
    Il più delle volte è incluso in un blocco "Display".
    Contiene solo blocchi "Testo" e interpreta i caratteri Markdown.

    - Esempi: iniziare una riga con # per visualizzare un titolo di livello 1, con ## per un titolo di livello 2, circondare una parola con due ** per metterla in grassetto...`,
  //BLOCK LATEX
  LATEX_TITLE: "LaTeX",
  LATEX_MESSAGE: "LaTeX %1",
  LATEX_TOOLTIP: `Consente di utilizzare la notazione LaTeX.
    Restituisce un oggetto HTML da visualizzare
    Il più delle volte è incluso in un blocco "Display".
    Contiene solo blocchi "Testo" e interpreta la notazione LaTeX.  LaTeX è un linguaggio molto potente per visualizzare testi scientifici e formule in modo elegante. Le espressioni devono essere precedute da "\\".
    Per ulteriori informazioni: consultare la documentazione`,

  LATEX_DOCUMENTATION: `Consente di utilizzare la notazione LaTeX.
    Restituisce un oggetto HTML da visualizzare
    Il più delle volte è incluso in un blocco "Display".
    Contiene solo blocchi "Testo" e interpreta la notazione LaTeX.  LaTeX è un linguaggio molto potente per visualizzare testi scientifici e formule in modo elegante. Le espressioni devono essere precedute da "\\".
    
    - Esempio 1: \\dfrac{ax+b}{b} in un blocco "LaTeX" contenuto in un blocco "Display" visualizza una frazione.
    - Esempio 2 : \\textrm{L'elemento } u_2 \\textrm{ è il secondo elemento della sequenza } u_n per mescolare testo in latino e matematica
    - Esempio 3 : f(n)=\\begin{cases} n/2, & \\mbox{se }n è pari} \\\\ 3n+1, & \\mbox{se }nmbox{ è dispari} \\´fine{cases}
`,
  //BLOCK SPECIAL_CHARACTER
  SPECIAL_CHARACTER_TOOLTIP:
    "Esegue un'interruzione di riga o aggiunge un separatore di riga orizzontale",

  //BLOCK VERSION
  VERSION_MESSAGE: "Creare le versioni dell'attività con",
  VERSION_DEFAULTVERSION: "versione predefinita",
  VERSION_VERSIONN: "versione n.",
  VERSION_LABEL: " con l'etichetta",
  VERSION_TOOLTIP: "Consente di creare un'attività multi-versione.",

  CLEAN_ACTIVITY_MESSAGE: "Cancella tutti i contenuti delle attività (beta)",
  CLEAN_ACTIVITY_TOOLTIP:
    "Cancella tutto il contenuto di un'attività. Spesso usato nel feedback per consentire di cancellare la cronologia delle affermazioni, delle domande e dei feedback precedenti e visualizzare le nuove informazioni",

  //BLOCK QUESTIONS
  //COMMON STRINGS CONTAINED IN QUESTION BLOCKS
  QUESTION_WARNING_NESTED_QUESTIONS:
    "Attenzione: per annidare le domande, è obbligatorio impostare il valore 'max tentativi' a 1 nel blocco di intestazione",
  QUESTION_GENERAL_MORE_OPTIONS_NB_PROPOSALS:
    "numero di proposte da visualizzare",
  QUESTION_GENERAL_MORE_OPTIONS_DEFAULT_FEEDBACKS: "feedback predefinito.",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY: "display",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY_EXTERNAL: "esterno",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY_INLINE: "annidato",
  QUESTION_GENERAL_MORE_OPTIONS_LEARNERANSWER_SAVEIN:
    "risposta del discente memorizzata in",
  QUESTION_GENERAL_MORE_OPTIONS_LEARNERANSWER_SAVEIN_NAMEVAR: "risposta",
  QUESTION_GENERAL_MORE_OPTIONS_QUESTION_SAVEIN: "domanda memorizzata in",
  QUESTION_GENERAL_MORE_OPTIONS_QUESTION_SAVEIN_NAMEVAR: "domanda",
  QUESTION_GENERAL_MORE_OPTIONS_FEEDBACKS: "⏎ feedback",
  //BLOCK QUESTION_TRUE_FALSE
  QUESTION_TRUE_FALSE_TRUE: "vero",
  QUESTION_TRUE_FALSE_FALSE: "falso",
  QUESTION_TRUE_FALSE_TITLE: "Domanda: rispondere vero o falso",

  QUESTION_TRUE_FALSE_MESSAGE:
    "❓ Domanda vero/falso %1 testo %2 ✅ risposta corretta %3 %4 opzioni avanzate",
  QUESTION_TRUE_FALSE_TOOLTIP: `Richiesta di conferma o rifiuto di una proposta.
    - Testo: contiene il testo della proposizione o un'istruzione.
    - Risposta esatta: Vero o falso. Può essere direttamente l'elemento logico vero o falso, oppure contenere il risultato di un test logico più complesso.
    Per ulteriori informazioni: consultare la documentazione.`,

  QUESTION_TRUE_FALSE_DOCUMENTATION: `Richiesta di conferma o rifiuto di una proposta.
   - Testo: contiene il testo della proposizione o un'istruzione.
   - Risposta esatta: Vero o falso. Può essere direttamente l'elemento logico vero o falso, oppure contenere il risultato di un test logico più complesso.
  
    Opzioni avanzate:
    - Visualizzazione: l'opzione "esterna" visualizza la domanda dopo la dichiarazione; l'opzione "annidata" visualizza la domanda all'interno della dichiarazione.
    - Risposta memorizzata in: consente di scegliere la variabile che memorizzerà la risposta del discente corrispondente a un booleano (vero o falso).
    - Feedback predefinito: consente di attivare o disattivare la visualizzazione del messaggio standard di superamento/errore della domanda.
    - Feedback: contiene i blocchi "Feedback" che consentono di attivare il feedback per questa domanda in base alla risposta del discente.
    
    Raw Options (JSON) contiene parametri specifici da fornire in formato JSON:
    - feedbackcolor (boolean) : "true" per impostazione predefinita. Se "false", la zona di risposta dell'allievo non viene più colorata in base alla sua risposta.
    - voto (boolean) : "true" per impostazione predefinita. Se "false", il blocco "Definisci il voto manualmente" imposterà il voto dell'allievo al termine di una sequenza.
    `,

  //BLOCK MULTIPLE_CHOICES_QUESTION
  QUESTION_MULTIPLE_CHOICES_TITLE: "Domanda a scelta multipla",

  QUESTION_MULTIPLE_CHOICES_MESSAGE:
    "❓ Domanda a scelta multipla %1 tipo %2 %3 testo %4 ✅ risposte corrette %5 ❌ risposte errate %6 %7 opzioni avanzate",

  QUESTION_MULTIPLE_CHOICES_MULTIPLE: "diverse risposte corrette.",
  QUESTION_MULTIPLE_CHOICES_UNIQUE: "una sola risposta giusta.",

  QUESTION_MULTIPLE_CHOICES_TOOLTIP: `Chiede di scegliere una o più risposte da un insieme di proposte.
    - Tipo: consente di definire un MCQ a scelta singola o multipla.
    - Testo: contiene il testo della proposizione o un'istruzione.
    - Risposte corrette: Elenco delle risposte considerate corrette.
    - Risposte errate: Elenco delle risposte considerate errate.
    Per ulteriori informazioni: consultare la documentazione.`,

  QUESTION_MULTIPLE_CHOICES_DOCUMENTATION: `Chiede di scegliere una o più risposte da un insieme di proposizioni.
    - Tipo: consente di definire un MCQ a scelta singola (una sola risposta possibile da un insieme di proposizioni) o un MCQ a scelta multipla (diverse risposte possibili da un insieme di proposizioni).
    - Testo: contiene il testo della proposizione o un'istruzione.
    - Risposte corrette: Elenco delle risposte considerate corrette (nel caso di un MCQ a scelta singola, l'elenco è un elenco contenente un solo elemento o un solo elemento).
    - Risposte errate: Elenco delle risposte considerate errate.

    Opzioni avanzate :
    - Numero di proposte da visualizzare : Lasciare vuoto per visualizzare tutte le possibilità (giuste e sbagliate). Se specificato, consente di selezionare in modo casuale un numero limitato di scelte da presentare al discente dall'insieme delle risposte giuste e sbagliate. In un MCQ a scelta singola, viene sempre proposta la risposta corretta. In un MCQ a scelta multipla, è possibile che vengano proposte solo risposte errate; in questo caso il discente non dovrà barrare nulla per essere corretto.
    - Visualizzazione: l'opzione "esterna" consente di visualizzare la domanda dopo la dichiarazione; l'opzione "annidata" consente di visualizzare la domanda all'interno di una dichiarazione.
    - Risposta memorizzata in: consente di scegliere la variabile che memorizzerà la risposta del discente. La variabile conterrà l'elenco delle voci spuntate dal discente.
    - Feedback predefinito: consente di attivare o disattivare la visualizzazione del messaggio standard di superamento/errore della domanda.
    - Feedback: contiene blocchi "Feedback" che consentono di attivare il feedback per questa domanda in base alla risposta del discente.
    
    Raw Options (JSON) contiene parametri specifici da fornire in formato JSON:
    - feedbackcolor (boolean) : "true" per impostazione predefinita. Se "false", la zona di risposta dell'allievo non viene più colorata in base alla sua risposta.
    - voto (boolean) : "true" per impostazione predefinita. Se "false", il blocco "Definisci il voto manualmente" imposterà il voto dell'allievo al termine di una sequenza.
    `,

  //BLOCK QUESTION_OPEN
  //=> ajouter var glob pour les inputs
  QUESTION_OPEN_TYPE_INTEGER_POSITIVE: "intero positivo",
  QUESTION_OPEN_TYPE_INTEGER: "intero",
  QUESTION_OPEN_TYPE_DECIMAL: "decimale",
  QUESTION_OPEN_TYPE_FRACTION: "frazione",
  QUESTION_OPEN_TYPE_TEXT: "texte",
  QUESTION_OPEN_TYPE_EXPRESSION: "espressione matematica.",
  QUESTION_OPEN_TYPE_LIST: "elenco o matrice (presto disponibile).",
  QUESTION_OPEN_OPTION_CASE_SENSITIVE: "Rispetto per la rottura.",
  QUESTION_OPEN_OPTION_TITLE: "opzioni grezze (JSON).",

  QUESTION_OPEN_TITLE: "Domanda aperta",

  QUESTION_OPEN_MESSAGE:
    "❓ Domanda aperta %1 testo %2 tipo di risposta prevista %3 %4 ✅ risposta corretta %5 %6 opzioni avanzate",
  QUESTION_OPEN_TOOLTIP: `Richiesta di fornire un valore di un certo tipo.
    - Testo: contiene il testo della proposta o un'istruzione.  
    - Tipo di risposta attesa: corrisponde al tipo di valore atteso.
    - Risposta esatta: il valore corrispondente alla risposta esatta. Può essere direttamente il valore, una variabile o contenere il risultato di un calcolo più complesso.
    Per saperne di più: consultare la documentazione.`,

  QUESTION_OPEN_DOCUMENTATION: `Richiesta di fornire un valore di un certo tipo.
    - Testo: contiene il testo della proposta o un'istruzione.
    - Tipo di risposta attesa: corrisponde al tipo di valore atteso.
    - Testo: la risposta attesa è un testo. Per essere considerata corretta, la risposta data deve essere inserita esattamente come la risposta corretta (rispettando maiuscole e minuscole, accenti, ecc.). Nel prossimo futuro verranno effettuate ulteriori regolazioni per tenere conto di maiuscole e minuscole, accenti, spazi superflui, errori di ortografia...
    - Intero o intero positivo : la risposta attesa è un numero intero, il valore numerico (Integer) corrispondente alla risposta corretta. Può essere il valore stesso, una variabile o il risultato di un calcolo più complesso.
    - Decimale: la risposta prevista è un numero decimale. Per essere considerata corretta, la risposta non deve essere arrotondata. Prossimamente verranno effettuate ulteriori regolazioni per tenere conto della precisione (numero di cifre significative)...
    - Frazione: la risposta attesa è una frazione. Per essere considerata corretta, la risposta deve essere inserita come frazione irriducibile.
    - Espressione: la risposta attesa è un'espressione simbolica (ad esempio, 3x+2). Per essere considerata corretta, la risposta data deve essere equivalente (ad esempio, 2+3*x).
    - Elenco o matrice: la risposta attesa è un elenco o una matrice inseriti nella forma [[1,2],[3,4]].
    - Risposta corretta: il valore corrispondente alla risposta corretta. Può essere direttamente il valore, una variabile o contenere il risultato di un calcolo più complesso.

    Opzioni avanzate:
    - Visualizzazione: l'opzione "esterna" consente di visualizzare la domanda dopo la dichiarazione; l'opzione "annidata" consente di visualizzare la domanda all'interno della dichiarazione.
    - Risposta memorizzata in: consente di scegliere la variabile che memorizzerà la risposta inserita dal discente.
    - Feedback predefinito: consente di scegliere se visualizzare o meno il messaggio standard di superamento/errore della domanda.
    - Feedback: contiene blocchi "Feedback" che consentono di attivare il feedback per questa domanda in base alla risposta del discente.
    
    Raw Options (JSON) contiene parametri specifici da fornire in formato JSON:
    
    - Per tutti i tipi di risposta previsti:
    • feedbackcolor (boolean) : "true" per impostazione predefinita. Se "false", la zona di risposta dell'allievo non viene più colorata in base alla sua risposta.
    • voto (boolean) : "true" per impostazione predefinita. Se "false", il blocco "Definisci il voto manualmente" imposterà il voto dell'allievo al termine di una sequenza.
    • emptyMeansZero (booleano): L'impostazione predefinita è "false". Se "true", una risposta lasciata in bianco viene considerata come il valore 0.
    • callbackSolution (booleano) : "false" per impostazione predefinita. Se "vera", la risposta corretta è una procedura che restituisce un booleano invece di un valore. Questa procedura restituisce true o false a seconda dell'analisi della risposta dell'utente.
    • length (numero): opzioni efficaci solo per le domande aperte annidate. 10 per impostazione predefinita, corrisponde approssimativamente al numero di caratteri che possono essere visualizzati nel campo di immissione.
    
    - Per i tipi di risposta previsti Testo, Intero e Decimale:
    • maxLength (numero): è efficace solo per le domande aperte annidate. Limita il numero di caratteri che il discente può inserire nel campo di input.
    
    - Per il tipo Testo :
    • caseSensitive (booleano): L'impostazione predefinita è "false". Se "vero", la risposta deve essere sensibile alle maiuscole e minuscole per essere considerata corretta.
    • spaceSensitive (booleano) : "false" per impostazione predefinita. Se "vero", la risposta non deve contenere spazi superflui per essere considerata corretta.
    
    - Per il tipo Decimale :
    • precision (intero): definisce a quante cifre significative deve essere arrotondata la risposta per essere considerata corretta.
    
    - Per il tipo di frazione :
    • irreducibleFraction (booleano): "false" per impostazione predefinita. Se "vero", la risposta deve essere irriducibile per essere considerata corretta.
    
    
    Esempio se è stato scelto il tipo Testo:
    {"caseSensitive" : true, "spaceSensitive" : true}
    indica che la risposta è considerata corretta se è sensibile alle maiuscole e non contiene spazi inutili.
    `,

  //BLOCK QUESTION_REORDER
  QUESTION_REORDER_TITLE: "Domanda: ordinare gli elementi.",
  QUESTION_REORDER_TEXT: "Ordina gli elementi",
  QUESTION_REORDER_MESSAGE:
    "❓ Domanda Ordine %1 testo %2 ✅ Elenco ordini %3 %4 Opzioni avanzate",
  QUESTION_REORDER_TOOLTIP: `Richiede l'ordinazione di articoli.
    - Elenco da ordinare : L'elenco degli elementi ordinati correttamente.
    Per ulteriori informazioni: consultare la documentazione.`,

  QUESTION_REORDER_DOCUMENTATION: `Richiede l'ordinazione di articoli.
    - Elenco degli ordini : L'elenco degli elementi ordinati correttamente.
  
    Opzioni avanzate :
    - Numero di proposte da visualizzare : Lasciare vuoto per visualizzare tutti gli articoli dell'elenco da ordinare. Se specificato, consente di selezionare in modo casuale un numero limitato di suggerimenti da presentare al discente.
    - Risposta memorizzata in: consente di scegliere la variabile che registrerà la risposta del discente. La variabile conterrà l'elenco degli elementi la cui posizione è corretta. Per deduzione verranno individuati gli elementi posizionati in modo errato.
    - Feedback predefinito: consente di attivare o disattivare la visualizzazione del messaggio standard di superamento/errore della domanda.
    - Feedback: contiene blocchi "Feedback" che consentono di attivare il feedback per questa domanda in base alla risposta del discente.
  
    Raw Options (JSON) contiene parametri specifici da fornire in formato JSON:
    - voto (boolean) : "true" per impostazione predefinita. Se "false", il blocco "Definisci il voto manualmente" imposterà il voto dell'allievo al termine di una sequenza.
    `,

  //BLOCK QUESTION_ASSOCIATE
  QUESTION_ASSOCIATE_TITLE: "Domanda: associare elementi.",
  QUESTION_ASSOCIATE_TEXT: "Associa gli elementi",
  QUESTION_ASSOCIATE_MESSAGE:
    "❓ Domanda associata %1 testo %2 ✅ Elenco articoli %3 ✅ Elenco funzioni %4 %5 Opzioni avanzate",
  QUESTION_ASSOCIATE_TOOLTIP: `Richiede di associare gli elementi alla loro caratteristica. Ogni elemento deve avere una caratteristica unica.
    - Elementi : L'elenco degli elementi.
    - Caratteristiche: l'elenco delle caratteristiche degli elementi corrispondenti.
    L'elemento con indice 'i' nell'elenco degli elementi ha la caratteristica con indice 'i' nell'elenco delle caratteristiche.
    Per ulteriori informazioni: consultare la documentazione.
    `,

  QUESTION_ASSOCIATE_DOCUMENTATION: `Richiede di associare gli elementi alla loro caratteristica. Ogni elemento deve avere una caratteristica unica.
    - Elementi : L'elenco degli elementi.
    - Caratteristiche: l'elenco delle caratteristiche degli elementi corrispondenti.
    L'elemento con indice 'i' nell'elenco degli elementi ha la caratteristica con indice 'i' nell'elenco delle caratteristiche.
  
    Opzioni avanzate:
    - Registra la risposta dell'allievo in: consente di scegliere la variabile che registrerà la risposta dell'allievo. La variabile conterrà l'elenco degli elementi correttamente associati alla loro caratteristica,
    - Numero di proposte da visualizzare : Lasciare vuoto per visualizzare tutti gli articoli e le loro caratteristiche. Se specificato, consente di selezionare casualmente un numero limitato di elementi con le loro caratteristiche.
    - Feedback predefinito: consente di attivare o meno la visualizzazione del messaggio standard di successo o fallimento della domanda.
    - Feedback: contiene blocchi "Feedback" che consentono di attivare il feedback per questa domanda in base alla risposta del discente.
  
    Raw Options (JSON) contiene parametri specifici da fornire in formato JSON:
    - voto (boolean) : "true" per impostazione predefinita. Se "false", il blocco "Definisci il voto manualmente" imposterà il voto dell'allievo al termine di una sequenza.
    `,

  //BLOC QUESTION_FIGURE
  QUESTION_FIGURE_TITLE: "Domanda su un grafico",
  QUESTION_FIGURE_MESSAGE:
    "❓ Domanda su un grafico %1 grafico rilevante %2 %3 ✅ condizione risposta giusta %4 %5 opzioni avanzate",
  QUESTION_FIGURE_TOOLTIP: `Richiesta di interagire su un grafico (spostare punti, costruire una figura...).
    - Grafico interessato: variabile in cui è memorizzato il grafico.
    - Condizione di risposta corretta: risultato booleano di un test (ad esempio, test sulle coordinate di un punto).
    `,

  QUESTION_FIGURE_DOCUMENTATION: `Richiesta di interagire su un grafico (spostare punti, costruire una figura...).
    - Grafico interessato: variabile in cui è memorizzato il grafico.
    - Condizione di risposta corretta: risultato booleano di un test (ad esempio, test sulle coordinate di un punto).
   
    Raw Options (JSON) contiene parametri specifici da fornire in formato JSON:
    - voto (boolean) : "true" per impostazione predefinita. Se "false", il blocco "Definisci il voto manualmente" imposterà il voto dell'allievo al termine di una sequenza.
    `,

  //CATEGORY FEEDBACK
  FEEDBACK_MESSAGE_TYPE_MESSAGE:
    "Imposta il tono dei messaggi di feedback su %1",
  FEEDBACK_MESSAGE_TYPE_KIDS: "Bambini/ragazzi",
  FEEDBACK_MESSAGE_TYPE_NEUTRAL: "Neutro",
  FEEDBACK_MESSAGE_TYPE_FORMAL: "Formale",
  FEEDBACK_MESSAGE_TYPE_TOOLTIP: `Scegliere il tono utilizzato per i messaggi di feedback da visualizzare. 
  Il tono dei messaggi di feedback può essere neutro, orientato ai bambini/adolescenti o agli adulti (formale). 
  Il tono predefinito per i messaggi di feedback è neutro.`,

  //BLOCK FEEDBACK
  FEEDBACK_TITLE: "feedback.",
  FEEDBACK_MESSAGE: "⏎ Feedback (deprecato) %1 se %2 visualizza %3",
  FEEDBACK_TOOLTIP: `Consente di visualizzare i messaggi in base ai test logici.
    - if: corrisponde al test logico che attiva la visualizzazione del testo. Il più delle volte il test logico viene eseguito sulla variabile che registra la risposta dell'allievo.
    - visualizza: il testo da visualizzare se il test è vero. È possibile scegliere qualsiasi elemento visualizzabile (testo, grafica, ecc.).`,

  FEEDBACK_LOCAL_TITLE: "Esempio",
  //PSEUDO FEEDBACK BLOCKS
  FEEDBACK_GLOBAL_EXAMPLE_DOCUMENTATION: `Questo set è un esempio precostituito da integrare alla fine di un'attività.
In base alle risposte del discente alle domande, viene visualizzato un messaggio personalizzato.`,
  FEEDBACK_TEST_ATTEMPTS_DOCUMENTATION: `Questo set è un esempio precostituito da includere nelle opzioni avanzate di un blocco di domande o di un blocco di feedback globale.
    Fornisce un modo semplice per verificare il tentativo attuale o i tentativi rimanenti dell'allievo. In questo modo è possibile progettare un feedback progressivo che tenga conto del numero di tentativi consumati.`,

  //BLOCK FEEDBACK GLOBAL
  FEEDBACK_GLOBAL_TITLE: "feedback globale.",
  FEEDBACK_GLOBAL_MESSAGE: "feedback globale %1",
  FEEDBACK_GLOBAL_TOOLTIP:
    "Contiene blocchi che attivano il feedback relativo a questa attività e a tutte queste domande. Il più delle volte il feedback complessivo è una funzione delle risposte degli allievi",

  //BLOCK FEEDBACK_TYPE
  FEEDBACK_TYPE_TITLE: "type de rétroaction",
  FEEDBACK_TYPE_MESSAGE: "type de rétroaction %1",
  FEEDBACK_TYPE_TOOLTIP: `doit être utilisé au sein des rétroactions d'une question ou du bloc rétroactions globales.
    - type de rétroaction : permet de choisir le type de rétroaction à afficher.
    `,

  //BLOCK ISSOLUTIONFOUND
  FEEDBACK_IS_SOLUTION_FOUND: "La soluzione a questo problema è stata trovata",
  FEEDBACK_ARE_ALL_SOLUTIONS_FOUND:
    "Tutte le soluzioni alle domande sono state trovate",
  FEEDBACK_IS_SOLUTION_FOUND_TOOLTIP: `deve essere usato all'interno del feedback di una domanda o del blocco di feedback globale.
  - soluzione alla domanda trovata: restituisce true se la soluzione alla domanda è stata trovata.
  - tutte le soluzioni alle domande dell'attività trovate: restituisce true se sono state trovate tutte le soluzioni alle domande dell'attività.
     `,

  //BLOCK CURRENT_ATTEMPT
  FEEDBACK_CURRENT_ATTEMPT_MESSAGE: "tentativo di corso da parte del discente.",
  FEEDBACK_CURRENT_ATTEMPT_TOOLTIP: `deve essere utilizzato all'interno del feedback di una domanda o del blocco di feedback globale.
  - Restituisce un numero intero corrispondente al numero del tentativo corrente dell'allievo.`,

  //BLOCK MAX_ATTEMPTS
  FEEDBACK_MAX_ATTEMPTS_MESSAGE: "tentativi massimi di attività.",
  FEEDBACK_MAX_ATTEMPTS_TOOLTIP: `deve essere utilizzato all'interno del feedback di una domanda o del blocco di feedback globale.
  - Restituisce un numero intero corrispondente al numero massimo di tentativi definiti nell'attività.`,

  //BLOCK MESSAGE
  FEEDBACK_MESSAGE_TOOLTIP: "Restituisce un messaggio di feedback predefinito.",
  FEEDBACK_MESSAGE_MESSAGE: "messaggio",
  FEEDBACK_MESSAGE_SOLUTION_FOUND_ATFIRSTATTEMPT:
    "Soluzione trovata al primo tentativo",
  FEEDBACK_MESSAGE_SOLUTION_FOUND: "Soluzione trovata",
  FEEDBACK_MESSAGE_SOLUTION_NOTFOUND_BUTREMAININGATTEMPTS:
    "Soluzione non trovata ma tentativi rimanenti",
  FEEDBACK_MESSAGE_SOLUTION_NOTFOUND: "Soluzione non trovata",

  CONTEXT_QUESTION_MESSAGE: "Nel contesto della domanda %1 %2 %3",
  CONTEXT_QUESTION_TOOLTIP:
    "Consente di lavorare nel contesto di una domanda. Utile per esternare il feedback di una domanda di procedura",

  SET_GRADE_MESSAGE: "Interrompere l'attività e impostare il grado a %1%.",
  SET_GRADE_TOOLTIP:
    "Questo blocco imposta manualmente un voto per l'attività e termina l'attività.. Questo voto sarà registrato nelle statistiche di una sequenza e sostituirà quello predefinito.",

  SET_ANALYTIC_MESSAGE:
    "Registrare un'analitica di apprendimento con chiave %1 e valore %2",
  SET_ANALYTIC_TOOLTIP:
    "Questo blocco consente di registrare un'analisi di apprendimento definita da una chiave e da un valore. Questa analitica viene utilizzata per registrare i valori durante l'esecuzione dell'attività da parte di un discente. Il valore dell'analitica può quindi essere consultato dalle statistiche di una sequenza.",

  //BLOCK IA
  IA_TITLE: "IA",
  IA_MESSAGE: "AI (in arrivo...) %1",
  IA_TOOLTIP:
    "Le funzioni di intelligenza artificiale saranno presto implementate",

  //MATH ARITHMETIC
  //RANDOM_NUMBER
  RANDOM_NUMBER_MESSAGE: "🎲 %1 casuale tra%2 e%3",
  RANDOM_NUMBER_INTEGER: "intero",
  RANDOM_NUMBER_DECIMAL: "decimale",
  RANDOM_NUMBER_TOOLTIP:
    "Restituisce un numero casuale (intero o decimale) maggiore o uguale al minimo e strettamente minore del massimo secondo una distribuzione uniforme",
  //BLOCK ROUND_DECIMAL
  ROUND_DECIMAL_MESSAGE: "arrotondamento da %1 a %2 decimali.",
  ROUND_DECIMAL_TOOLTIP:
    "Restituisce l'arrotondamento di un numero con n cifre decimali.",

  //BLOCK INTEGER_DECIMAL_PART
  INTEGER_DECIMAL_PART_MESSAGE: "%1 %2",
  INTEGER_DECIMAL_PART_INTEGER: "parte intera",
  INTEGER_DECIMAL_PART_DECIMAL: "parte decimale",
  INTEGER_DECIMAL_PART_TOOLTIP:
    "Restituisce la parte intera o decimale di un numero",

  //BLOCK SPLIT_NUMBER
  SPLIT_NUMBER_MESSAGE: "scompone il numero %1 in cifre.",
  SPLIT_NUMBER_TOOLTIP:
    "Restituisce l'elenco delle cifre che compongono un numero.",

  //BLOCK INTEGER_PART
  INTEGER_PART_MESSAGE: "parte intera di %1.",
  INTEGER_PART_TOOLTIP: "Restituisce la parte intera di un numero.",

  //BLOCK DECIMAL_PART
  DECIMAL_PART_MESSAGE: "parte decimale di %1.",
  DECIMAL_PART_TOOLTIP: "Restituisce la parte decimale di un numero.",

  //BLOCK GCD_LCM
  GCD_LCM_OPERATOR_GCD: "PGCD",
  GCD_LCM_OPERATOR_LCM: "PCCM",
  GCD_LCM_MESSAGE: "%1 dell'elenco %2.",
  GCD_LCM_TOOLTIP:
    "Restituisce il PGCD o il PPCM di tutti i numeri dell'elenco.",

  /////////////////////
  //MATH GEOMETRY
  BOARD_TITLE: "grafico",
  BOARD_GEOMETRIC_MESSAGE:
    "📈 Grafico Xmin%1 Xmax%2 Ymin%3 Ymax%4 ⊞%5 %6 %7▦ %8 %9🕹",
  BOARD_SIZE_SMALL: "piccolo",
  BOARD_SIZE_MEDIUM: "media",
  BOARD_SIZE_BIG: "grande",

  BOARD_AXES_XY: "X & Y",
  BOARD_AXES_X: "Solo X",
  BOARD_AXES_Y: "Solo Y",
  BOARD_AXES_NONE: "Nessuno",

  BOARD_TOOLTIP: `
  Crea un grafico in base ai limiti superiore e inferiore scelti, con o senza visualizzazione degli assi e con o senza griglia.
  Di solito è seguito da blocchi Draw che disegnano diversi elementi geometrici nel grafico.
  Può essere incluso in un blocco Dimensione (XL-S) per modificare le dimensioni di visualizzazione del grafico.
  `,
  //DRAW
  DRAW_MESSAGE: "Disegna %1", //Obsolete
  DRAW_IN_BOARD_MESSAGE: "Disegna %1 nel grafico%2",
  DRAW_TOOLTIP: `Dessine un élément géométrique.
  Contient un element géométrique à dessiner dans le graphique sélectionné.
  Préalablement, une variable graphique doit être définie.`,

  //ERASE IN BOARD
  ERASE_IN_BOARD_MESSAGE: "cancellare %1 nel grafico%2",
  ERASE_IN_BOARD_TOOLTIP: `Efface un élément géométrique.
  Contient la variable de l'élement géométrique à effacer dans le graphique sélectionné.
  Préalablement, la variable de l'élément graphique et le graphique doivent être définies.`,

  //ERASE IN BOARD
  ERASE_ALL_BOARD_MESSAGE: "Elimina tutti gli elementi del grafico %1",
  ERASE_ALL_BOARD_TOOLTIP: `Elimina tutti gli elementi geometrici di un grafo.
  Contiene la variabile del grafico da eliminare.
  La variabile del grafico deve essere definita in anticipo.`,

  //BLOCK POLYGON
  POLYGON_MESSAGE: "poligono con vertici %1",
  POLYGON_TOOLTIP: `Restituisce un poligono di n vertici.
    Contiene un elenco di vertici. Per definire un colore, includerlo in un blocco di colore.
    Incluso generalmente in un blocco "Disegno".`,

  //POINT
  POINT_MESSAGE: "punto %1 x%2 y%3 %4 %5 opzioni ",
  POINT_TOOLTIP_WITHLABEL: "tracciare il punto.",
  POINT_TOOLTIP_SHOWINFOBOX: "visualizzare i dati di contatto.",
  POINT_TOOLTIP_FIXED: "fisso o mobile.",
  POINT_TOOLTIP:
    "Restituisce un punto con coordinate x e y. Opzioni: vedi documentazione",
  POINT_DOCUMENTATION: `Renvoie un point de coordonnées x et y.
  Opzioni:
  - 🔵: traccia il punto.
  - 💬: visualizza le coordinate del punto al passaggio del mouse.
  - 🔒: definisce se il punto è fisso o può essere spostato.
  - 🧲 : definisce gli attrattori =>
  - Un attrattore può essere un numero intero: il punto può essere posizionato solo su ascissa e ordinata multiple di questo numero.
  - Un attrattore può essere un elenco [a,b]: il punto può essere posizionato solo sulle ascisse multiple di a e sulle ordinate multiple b.
  - Un attrattore può essere un'altra figura: il punto può essere posizionato solo sul contorno di questa figura.`,

  //POINT COORDINATE
  FIGURE_COORDINATE_MESSAGE: "coordinata %1 del punto memorizzato in %2.",
  FIGURE_COORDINATE_TOOLTIP: `Restituisce la coordinata x o y del punto memorizzato in una variabile.
  Il punto deve essere prima memorizzato in una variabile.`,

  //LINE
  LINE_LINE: "destra",
  LINE_SEGMENT: "segmento",
  LINE_ARROW: "freccia",
  LINE_DOTTED: "linea tratteggiata",
  LINE_MESSAGE: "%1 che passa attraverso%2 e%3",
  LINE_TOOLTIP: `Restituisce una linea, un segmento o una freccia attraverso due punti.`,
  //TANGENTE
  TANGENTE_MESSAGGIO: "tangente passante per %1",
  TANGENT_TOOLTIP: `Invia una tangente definita da un punto con uno o più attrattori`,
  //CIRCLE
  CIRCLE_MESSAGE: "cerchio di centro%1 e raggio%2",
  CIRCLE_TOOLTIP: `Restituisce un cerchio definito da un punto che ne rappresenta il centro e il raggio..`,
  //DISK - SECTOR - CIRCLE PORTION
  SECTOR_MESSAGE: "area circolare con centro%1 e definita da punto%2 e punto%3",
  SECTOR_TOOLTIP:
    "Restituisce un settore è definito da tre punti: Il centro p1 del settore, un secondo punto p2 che definisce il raggio e un terzo punto p3 che definisce l'angolo del settore. Il settore viene sempre disegnato in senso antiorario da p2 a p3",
  SECTOR_DOCUMENTATION: `
  Restituisce un settore è definito da tre punti: Il centro p1 del settore, un secondo punto p2 che definisce il raggio e un terzo punto p3 che definisce l'angolo del settore. Il settore viene sempre disegnato in senso antiorario da p2 a p3
  Parametri avanzati (Applicare il blocco imposta ... con ...) :
      • "arcOnly": true / false
      • "hasFirstArrow": true / false
      • "hasLastArrow": true / false
  `,
  //BOARD_TEXT
  BOARD_TEXT_MESSAGE: "testo %1 posizionato a %2",
  BOARD_TEXT_TOOLTIP:
    "Restituisce un testo definito da un testo e dalla sua posizione attraverso un punto",
  //BLOCK RANDOMPOLYGON
  RANDOMPOLYGON_MESSAGE: "🎲 poligono casuale con %1 lati",
  RANDOMPOLYGON_TOOLTIP: `Restituisce un poligono con n vertici scelti a caso. Le coordinate dei vertici sono scelte in un grafico predefinito.`,
  //BLOCK REGULARPOLYGON
  REGULARPOLYGON_MESSAGE: "poligono regolare di centro%1 di %2 lati e raggio%3",
  REGULARPOLYGON_TOOLTIP: `Restituisce un poligono regolare definito dal centro, dal numero di lati e dal raggio.`,

  //BLOCK RECTANGLE
  RECTANGLE_MESSAGE: "rettangolo di lunghezza %1 %2 di larghezza %3 %4",
  RECTANGLE_TOOLTIP:
    "Restituisce un rettangolo definito dalla sua lunghezza, larghezza e posizionato in modo casuale in un grafico. Le coordinate dei vertici sono scelte da un grafico predefinito",
  //BLOCK FIGURE_PERIMETER
  FIGURE_PERIMETER_MESSAGE: "perimetro della figura %1.",
  FIGURE_PERIMETER_TOOLTIP: `Restituisce il perimetro della figura geometrica
  Contiene una figura geometrica (rettangolo, poligono...).`,
  //BLOCK FIGURE_AREA
  FIGURE_AREA_MESSAGE: "area della figura %1",
  FIGURE_AREA_TOOLTIP: `Restituisce l'area della figura geometrica
  Contiene una figura geometrica (rettangolo, poligono, cerchio,...).`,

  //BLOCK FIGURE_TRANSFORMS
  FIGURE_ROTATE_MESSAGE: "esecuzione %1 di %2°.",
  FIGURE_ROTATE_TOOLTIP: `Ruotare la figura di x gradi.`,
  FIGURE_TRANSLATE_MESSAGE: "traduttore %1 da [%2,%3]",
  FIGURE_TRANSLATE_TOOLTIP: `Traslare la figura secondo il vettore [x,y].`,
  FIGURE_SCALE_MESSAGE: "scala %1 per [%2,%3]",
  FIGURE_SCALE_TOOLTIP: "Scala la figura in base al vettore [x,y].",
  //BLOCK EUCLIDEAN_DISTANCE_TWOPOINTS
  EUCLIDEAN_DISTANCE_TWOPOINTS_MESSAGE: "Distanza tra %1 e %2",
  EUCLIDEAN_DISTANCE_TWOPOINTS_TOOLTIP: `Restituisce la distanza tra due punti. 
    Contiene due punti.`,
  //BLOCK EUCLIDEAN_DISTANCE
  EUCLIDEAN_DISTANCE_MESSAGE: "Distanza tra x1%1 y1%2 e x2%3 y2%4.",
  EUCLIDEAN_DISTANCE_TOOLTIP: `Restituisce la distanza tra due punti.
  Contiene due punti.`,
  //BLOCK FIGURE_CLONE
  FIGURE_CLONE_MESSAGE: "clone di %1",
  FIGURE_CLONE_TOOLTIP: `Restituisce un clone di una figura geometrica
  Contiene una figura geometrica (rettangolo, poligono, cerchio...).`,

  //MATH ALGEBRA
  //BLOCK RANDOMPOLYNOM
  RANDOMPOLYNOM_MESSAGE: "🎲 polinomio casuale di grado %1 con coefficienti %2",
  RANDOMPOLYNOM_TOOLTIP: `Restituisce un polinomio casuale di tipo espressione, espresso con la variabile 'x'. Esempio: x^2+2x-1.`,

  //BLOCK RANDOMPOLYNOM
  POLYNOM_WITH_COEFFICIENTS_MESSAGE: "polinomio con coefficienti %1",
  POLYNOM_WITH_COEFFICIENTS_TOOLTIP: `Restituisce un polinomio definito da un elenco di coefficienti.`,

  //BLOCK GRAPH_OF_FUNCTION
  GRAPH_OF_FUNCTION_MESSAGE: "grafico di f(x)= %1",
  GRAPH_OF_FUNCTION_TOOLTIP:
    "Restituisce la rappresentazione grafica della funzione definita da un testo o da un'espressione",

  //BLOCCO GRAFICO_DI_FUNZIONE_INTERVALLO
  GRAPH_OF_FUNCTION_INTERVAL_MESSAGE: "grafico di f(x)= %1 su [ %2 , %3 ]",
  GRAPH_OF_FUNCTION_INTERVAL_TOOLTIP:
    "Restituisce la rappresentazione grafica della funzione definita da un testo o da un'espressione in un intervallo",

  //BLOCCO AREA_SOTTO_FUNZIONE_INTERVALLO
  AREA_UNDER_FUNCTION_INTERVAL_MESSAGE: "area sotto f(x)= %1 su [ %2 , %3 ]",
  AREA_SOTTO_INTERVALLO_DI_FUNZIONE_TOOLTIP:
    "Restituisce la rappresentazione grafica dell'area sotto la funzione definita da un testo o da un'espressione in un intervallo",

  //BLOCK EXPRESSION
  EXPRESSION_MESSAGE: "espressione %1",
  EXPRESSION_TOOLTIP:
    "Restituisce un'espressione definita dal testo (ad esempio, 2*x+3)",
  //BLOCK DEGREE
  DEGREE_MESSAGE: "grado del polinomio %1 rispetto a %2.",
  DEGREE_TOOLTIP:
    "Restituisce il grado di un polinomio rispetto alla variabile definita",
  //BLOCK COEFFICIENTS
  COEFFICIENTS_MESSAGE:
    "elenco dei coefficienti del polinomio %1 rispetto a %2",
  COEFFICIENTS_TOOLTIP:
    "Restituisce l'elenco dei conofficienti (dal grado più piccolo al più grande) di un polinomio rispetto alla variabile definita",
  //PSEUDO BLOCK ADD POLYNOM
  COEFFICIENTS_OPERATOR_TOOLTIP:
    "Restituisce un nuovo polinomio che è l'addizione di due polinomi. Funziona anche con la sottrazione",
  //BLOCK DERIVATIVE
  DERIVATIVE_MESSAGE: "derivata di %1 rispetto a %2",
  DERIVATIVE_TOOLTIP:
    "Restituisce la derivata di un'espressione rispetto alla variabile definita",
  //BLOCK PRIMITIVE
  PRIMITIVE_MESSAGE: " primitiva di %1 rispetto a %2",
  PRIMITIVO_TOOLTIP:
    "Restituisce la primitiva di un'espressione rispetto alla variabile definita",
  //INTEGRAL
  INTEGRAL_MESSAGE: "integrale di %1 rispetto a %2 su [ %3 , %4 ]",
  INTEGRAL_TOOLTIP:
    "Restituisce l'integrale di un'espressione rispetto alla variabile definita su un intervallo",

  //BLOCK EVALUATE
  EVALUATE_MESSAGE: "valore di %1 per %2=%3",
  EVALUATE_TOOLTIP:
    "Restituisce la valutazione dell'espressione quando la sua variabile è uguale a un valore",
  //BLOCK SIMPLIFY
  SIMPLIFY_MESSAGE: "semplificazione di %1",
  SIMPLIFY_TOOLTIP: "Restituisce la forma semplificata di un'espressione.",
  //BLOCK EXPAND
  EXPAND_MESSAGE: "sviluppo di %1.",
  EXPAND_TOOLTIP: "Restituisce la forma espansa di un'espressione.",
  //BLOCK UNIT
  UNIT_MESSAGE: "Valore numerico %1 unità %2",
  UNIT_TOOLTIP:
    "Restituisce un oggetto Unità che può essere visualizzato o convertito in un'altra unità",
  UNIT_DOCUMENTATION: `Restituisce un oggetto Unità che può essere visualizzato o convertito in un'altra unità.
   Elenco delle unità accettate : 
- Length 	meter (m), inch (in), foot (ft), yard (yd), mile (mi), link (li), rod (rd), chain (ch), angstrom, mil
- Surface area 	m2, sqin, sqft, sqyd, sqmi, sqrd, sqch, sqmil, acre, hectare
- Volume 	m3, litre (l, L, lt, liter), cc, cuin, cuft, cuyd, teaspoon, tablespoon
- Liquid volume 	minim, fluiddram (fldr), fluidounce (floz), gill (gi), cup (cp), pint (pt), quart (qt), gallon (gal), beerbarrel (bbl), oilbarrel (obl), hogshead, drop (gtt)
- Angles 	rad (radian), deg (degree), grad (gradian), cycle, arcsec (arcsecond), arcmin (arcminute)
- Time 	second (s, secs, seconds), minute (min, mins, minutes), hour (h, hr, hrs, hours), day (days), week (weeks), month (months), year (years), decade (decades), century (centuries), millennium (millennia)
- Frequency 	hertz (Hz)
- Mass 	gram(g), tonne, ton, grain (gr), dram (dr), ounce (oz), poundmass (lbm, lb, lbs), hundredweight (cwt), stick, stone
- Electric current 	ampere (A)
- Temperature 	kelvin (K), celsius (degC), fahrenheit (degF), rankine (degR)
- Amount of substance 	mole (mol)
- Luminous intensity 	candela (cd)
- Force 	newton (N), dyne (dyn), poundforce (lbf), kip
- Energy 	joule (J), erg, Wh, BTU, electronvolt (eV)
- Power 	watt (W), hp
- Pressure 	Pa, psi, atm, torr, bar, mmHg, mmH2O, cmH2O
- Electricity and magnetism 	ampere (A), coulomb (C), watt (W), volt (V), ohm, farad (F), weber (Wb), tesla (T), henry (H), siemens (S), electronvolt (eV)
- Binary 	bits (b), bytes (B)    
   `,
  //BLOCK CONVERT_INTO_UNIT
  CONVERT_INTO_UNIT_MESSAGE: "conversione di %1 in %2",
  CONVERT_INTO_UNIT_TOOLTIP:
    "Restituisce il valore dell'espressione convertito nella nuova unità",
  ///////////////////////////////////
  //BLOCKS FRACTION
  FRACTION_MESSAGE: "frazione %1 / %2",
  FRACTION_TOOLTIP:
    "Restituisce una frazione definita dal numeratore e dal denominatore",

  CONVERT_INTO_FRACTION_MESSAGE: "conversione di %1 in frazione",
  CONVERT_INTO_FRACTION_TOOLTIP: "Restituisce un numero come frazione.",

  FRACTION_NUMERATOR_DENOMINATOR_MESSAGE: "%1 di %2",
  FRACTION_NUMERATOR_DENOMINATOR_NUMERATOR: "numeratore",
  FRACTION_NUMERATOR_DENOMINATOR_DENOMINATOR: "denominatore",
  FRACTION_NUMERATOR_DENOMINATOR_TOOLTIP:
    "Restituisce il numeratore o il denominatore di una frazione",

  SIMPLIFY_FRACTION_MESSAGE: "frazione irriducibile di %1.",
  SIMPLIFY_FRACTION_TOOLTIP:
    "Restituisce una frazione nella sua forma irriducibile.",

  //MATH MATRIX
  //TABLE_DATA
  DATA_TABLE_TITLE: "tabella dati.",
  DATA_TABLE_TOOLTIP:
    "Restituisce un array in formato matrice composto dai valori definiti",

  //NUMPRY MATRIX (disable)
  NUMPY_SQUARE_MATRIX_TITLE: "matrice",
  MATRIX_TABLE_TOOLTIP: "Restituisce una matrice composta dai valori definiti",
  //MATRIX
  MATRIX_MESSAGE: "creare una matrice con %1 %2.",
  MATRIX_TOOLTIP:
    "Restituisce una matrice costruita dal testo [[1,2],[3,4]] o da un elenco già definito",
  //MATRIX3PARAMS (MATRIX_RANDOM)
  MATRIX3PARAMS_MESSAGE:
    "crea una matrice di %1 righe e %2 colonne riempita con %3",
  MATRIX3PARAMS_TOOLTIP: `Restituisce una matrice della dimensione definita riempita con un particolare valore o con il risultato di un calcolo.`,
  //MATRIXDETERMINANT
  MATRIXDETERMINANT_MESSAGE: "determinante della matrice %1.",
  MATRIXDETERMINANT_TOOLTIP: "Restituisce il determinante della matrice.",
  //MATRIX_SUM
  MATRIX_SUM_MESSAGE: "somma della matrice %1 e della matrice %2.",
  MATRIX_SUM_TOOLTIP: "Restituisce l'addizione delle due matrici.",
  //MATRIX_MULTIPLICATION
  MATRIX_MULTIPLICATION_MESSAGE:
    "prodotto matriciale della matrice %1 con la matrice %2",
  MATRIX_MULTIPLICATION_TOOLTIP:
    "Restituisce il prodotto matriciale di due matrici",
  //MATRIX_SCALAR
  MATRIX_SCALAR_MESSAGE: "prodotto(scalare) del numero %1 e della matrice %2.",
  MATRIX_SCALAR_TOOLTIP:
    "Restituisce il prodotto tra uno scalare e una matrice.",
  //MATRIX_SHORT_SET
  MATRIX_SHORT_SET_MESSAGE: "%1[%2,%3]=%4",
  MATRIX_SHORT_SET_TOOLTIP:
    "Definisce l'elemento di una matrice all'indice i,j",
  //MATRIX_SHORT_GET
  MATRIX_SHORT_GET_MESSAGE: "%1[%2,%3]",
  MATRIX_SHORT_GET_TOOLTIP:
    "Restituisce l'elemento di una matrice all'indice i,j",
  //////////////////LISTS
  //RANDOMLIST
  RANDOMLIST_MESSAGE: "Crea una lista di lunghezza %1 e riempila con %2.",
  RANDOMLIST_TOOLTIP: `Restituisce un elenco della dimensione definita riempito con un particolare valore o con il risultato di un calcolo.`,
  //LISTSSHUFFLE
  SHUFFLELIST_MESSAGE: "🎲 Mescola casualmente gli elementi dell'elenco %1",
  SHUFFLELIST_TOOLTIP:
    "Contiene l'elenco in cui gli elementi saranno mescolati",
  //BLOCK DELETE_DUPLICATE
  DELETE_DUPLICATES_MESSAGE: "Elimina i duplicati nell'elenco %1.",
  DELETE_DUPLICATES_TOOLTIP: "Rimuovi i duplicati dall'elenco.",
  //BLOCK DELETE_ELEMENT_FROM_LIST
  DELETE_ELEMENT_FROM_LIST_MESSAGE: "Elimina l'elemento %1 dall'elenco %2",
  DELETE_ELEMENT_FROM_LIST_TOOLTIP: "Cancellare un elemento da un elenco.",
  //BLOCK COUNT_SAME_ELEMENT_LIST
  COUNT_SAME_ELEMENT_LIST_MESSAGE:
    "conta il numero di occorrenze di %1 nell'elenco %2",
  COUNT_SAME_ELEMENT_LIST_TOOLTIP:
    "Returns the number of occurrences of an element in a list.",
  //LIST_SHORT_SET
  LIST_SHORT_SET_MESSAGE: "%1[%2]=%3",
  LIST_SHORT_SET_TOOLTIP: "Imposta l'elemento di un elenco all'indice i.",
  //LIST_SHORT_GET
  LIST_SHORT_GET_MESSAGE: "%1[%2]",
  LIST_SHORT_GET_TOOLTIP: "Restituisce l'elemento di un elenco all'indice i.",

  //CATMEDIA
  //BLOCK ELEDA_IMAGE
  IMAGE_MESSAGE: "🏞 immagine %1 URL %2 legenda %3 %4opzioni",
  IMAGE_WIDTH: "Larghezza",
  IMAGE_HEIGHT: "Altezza",
  IMAGE_TOOLTIP: `Visualizza un'immagine tramite un link.
    - URL: contiene l'indirizzo o il link dell'immagine.`,

  IMAGE_DOCUMENTATION: `Visualizza un'immagine tramite un link.
    - URL: contiene l'indirizzo o il link dell'immagine
  
    Opzioni :
    - Larghezza: consente di impostare una larghezza fissa per l'immagine.
    - Altezza: consente di impostare un'altezza fissa per l'immagine.`,

  //BLOCK ELEDA_VIDEO
  VIDEO_MESSAGE: "📽 video %1 Codice di integrazione %2 legenda %3",
  VIDEO_TOOLTIP: `Visualizza un video utilizzando un codice embed.
    - Codice di incorporamento: contiene il codice di incorporamento del video (fare clic con il pulsante destro del mouse su un video, quindi copiare il codice di incorporamento).`,

  //BLOCK ELEDA AUDIO
  ELEDA_AUDIO_MESSAGE:
    "♬ audio %1 numero di ripetizioni %2 Link (mp3, mp4...) %3 legenda %4",

  //BLOCK TABLE (HTML) MATRIX
  TABLE_MATRIX_TITLE: "tavolo",
  GRID_MATRIX_TITLE: "griglia",
  TABLE_MATRIX_TOOLTIP:
    "Crea una tabella HTML a partire dagli elementi inseriti.",

  //BLOCK TABLE (HTML) COLUMN
  TABLE_COLUMN_TITLE: "colonne",
  TABLE_COLUMN_TOOLTIP: "Creare una colonna che generi celle per la tabella",

  TEXT_JOIN_TITLE: "creare un testo con",
  TEXT_JOIN_HELPURL: "",
  TEXT_JOIN_TOOLTIP: "",

  //block eleda_alignment
  ELEDA_ALIGNMENT_TEXT: "allineamento",

  //CLONE
  CLONE_MESSAGE: "clone di %1",

  //Backpack
  EMPTY_BACKPACK: "Vide",
  REMOVE_FROM_BACKPACK: "Rimuovere dallo zaino.",
  COPY_TO_BACKPACK: "Copia nello zaino",
  COPY_ALL_TO_BACKPACK: "Copiare tutti i blocchi nello zaino",
  PASTE_ALL_FROM_BACKPACK: "Incolla tutti i blocchi nell'area di lavoro.",

  //TEXT_CHANGECASE
  TEXT_CHANGECASE_OPERATOR_FIRSTLETTERCASE:
    "in Iniziale maiuscola per la prima parola",

  //Dictionary
  DICTIONARY_TITLE: "Dizionario",
  DICTIONARY_MESSAGE: "dizionario %1 %2",
  DICTIONARY_HELPURL: "",
  DICTIONARY_TOOLTIP: "",

  //random_verb
  RANDOM_VERB_TITLE: "Verbo casuale.",
  RANDOM_VERB_MESSAGE: "🎲 verbo casuale dal dizionario %1 %2 del gruppo %3",
  RANDOM_VERB_HELPURL: "",
  RANDOM_VERB_TOOLTIP: "",

  //selected verb
  SELECTED_VERB_TITLE: "Verbe",
  SELECTED_VERB_MESSAGE: "verbo dizionario %1 %2 %3 con infinito %4",
  SELECTED_VERB_HELPURL: "",
  SELECTED_VERB_TOOLTIP: "",

  //verb_getAttribute
  VERB_GETATTRIBUTE_TITLE: "Ottenere l'attributo di un verbo.",
  VERB_GETATTRIBUTE_MESSAGE: "ottenere il %1 del verbo %2.",
  VERB_GETATTRIBUTE_HELPURL: "",
  VERB_GETATTRIBUTE_TOOLTIP: "",

  //conjugate_verb
  CONJUGATE_VERB_TITLE: "Ottenere le coniugazioni di un verbo.",
  CONJUGATE_VERB_MESSAGE:
    "ottenere le coniugazioni dei verbi da %1 a %2 dal dizionario %3",
  CONJUGATE_VERB_HELPURL: "",
  CONJUGATE_VERB_TOOLTIP: "",

  //selected_determinantDefInfDemons
  SELECTED_DETERMINANTDEFINFFEMONS_TITLE: "Determinante in/definito di un nome",
  SELECTED_DETERMINANTDEFINFFEMONS_MESSAGE:
    "determinante del dizionario %1 %2 del tipo %3 per il nome %4",
  SELECTED_DETERMINANTDEFINFFEMONS_HELPURL: "",
  SELECTED_DETERMINANTDEFINFFEMONS_TOOLTIP: "",

  //determinantDefInfDemons_getAttribute
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_TITLE:
    "Ottenere un attributo da un determinante",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_MESSAGE:
    "ottenere il %1 del determinatore (in)definito o dimostrativo %2",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_HELPURL: "",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_TOOLTIP: "",

  //selected_determinantPoss
  SELECTED_DETERMINANTPOSS_TITLE: "Determinante possessivo di un sostantivo",
  SELECTED_DETERMINANTPOSS_MESSAGE:
    "dizionario determinante possessivo %1 %2 per il sostantivo %3",
  SELECTED_DETERMINANTPOSS_HELPURL: "",
  SELECTED_DETERMINANTPOSS_TOOLTIP: "",

  //determinantPoss_getListForNumber
  DETERMINANTPOSS_GETLISTFORNUMBER_TITLE: "Elenco dei determinatori possessivi",
  DETERMINANTPOSS_GETLISTFORNUMBER_MESSAGE:
    "ottenere l'elenco a %1 del determinante possessivo %2",
  DETERMINANTPOSS_GETLISTFORNUMBER_HELPURL: "",
  DETERMINANTPOSS_GETLISTFORNUMBER_TOOLTIP: "",

  //random_name
  RANDOM_NAME_TITLE: "Nome casuale.",
  RANDOM_NAME_MESSAGE: "🎲 nome casuale dal dizionario %1 %2 con genere %3",
  RANDOM_NAME_HELPURL: "",
  RANDOM_NAME_TOOLTIP: "",

  //selected_name
  SELECTED_NAME_TITLE: "Nom",
  SELECTED_NAME_MESSAGE: "nome del dizionario %1 %2 con l'intestazione %3.",
  SELECTED_NAME_HELPURL: "",
  SELECTED_NAME_TOOLTIP: "",

  //name_getAttribute
  NAME_GETATTRIBUTE_TITLE: "Ottenere l'attributo di un nome",
  NAME_GETATTRIBUTE_MESSAGE: "ottenere il %1 del nome %2.",
  NAME_GETATTRIBUTE_HELPURL: "",
  NAME_GETATTRIBUTE_TOOLTIP: "",

  //random_adjective
  RANDOM_ADJECTIVE_TITLE: "Aggettivo casuale.",
  RANDOM_ADJECTIVE_MESSAGE: "🎲 aggettivo casuale dal dizionario %1",
  RANDOM_ADJECTIVE_HELPURL: "",
  RANDOM_ADJECTIVE_TOOLTIP: "",

  //selected_adjective
  SELECTED_ADJECTIVE_TITLE: "Aggettivo",
  SELECTED_ADJECTIVE_MESSAGE: "aggettivo del dizionario %1 %2 con il titolo %3",
  SELECTED_ADJECTIVE_HELPURL: "",
  SELECTED_ADJECTIVE_TOOLTIP: "",

  //adjective_getAttribute
  ADJECTIVE_GETATTRIBUTE_TITLE: "Ottenere l'attributo di un aggettivo",
  ADJECTIVE_GETATTRIBUTE_MESSAGE: "ottenere il %1 dell'aggettivo %2",
  ADJECTIVE_GETATTRIBUTE_HELPURL: "",
  ADJECTIVE_GETATTRIBUTE_TOOLTIP: "",

  //split_into_words_letters
  SPLIT_INTO_WORDS_LETTERS_TITLE: "Tagliare il testo.",
  SPLIT_INTO_WORDS_LETTERS_MESSAGE: "Taglia il testo %1 %2 in %3.",
  SPLIT_INTO_WORDS_LETTERS_HELPURL: "",
  SPLIT_INTO_WORDS_LETTERS_TOOLTIP: "",

  //french words
  MALE: "masculin",
  FEMALE: "femminile",
  SINGULAR: "singolare",
  PLURAL: "plurale",
  RANDOM: "casuale",
  GENDER: "tipo",
  NUMBER: "numero",
  WORDS: "parole",
  LETTERS: "lettere",

  //LOGIC CATEGORY (ADD DOC TO BLOCKLY EXISTING BLOCKS)
  LOGIC_COMPARE_DOCUMENTATION:
    "Restituisce true se entrambi gli input sono uguali. = e ≠ possono essere utilizzati per confrontare anche oggetti geometrici.",
};
